<template>
	<nav
		id="nav_col"
		class="navbar navbar-expand-lg nav-pills sticky-top flex-lg-column"
	>
		<div class="collapse navbar-collapse" id="navbarNav">
			<div
				class="navbar-nav gap-1 justify-content-between align-items-left flex-column"
			>
				<RouterLink
					class="onload pill nav-link px-3"
					:class="[n.color, n.font]"
					v-for="n in nav_data.filter(n => !n.disabled)"
					:to="n.to"
					>{{ n.text }}</RouterLink
				>
				<a
					class="onload pill nav-link px-3 white blog"
					href="https://blog.shadowlerone.ca"
				>
					blog
				</a>
			</div>
		</div>
		<!-- </div> -->
	</nav>
</template>
<script setup>
import { watch, ref } from "vue";
import nav_data from "../data/nav.json";
import Fade from "./Transitions/Fade.vue";
let watermark_src = ref("/Watermark v3 black.png");
watermark_src.value = "/NewsLogo.png";
</script>
